export default () => {
  return {
    /**
     * Store for caching names of program behavior groups and items
     */
    programBehaviourDataGroupCache: {},
    programBehaviourDataItemCache: {},

    allProgramBehaviourDataGroupsLoaded: false,
    allProgramBehaviourDataItemsLoaded: {},

    abcDraft: JSON.parse(localStorage.getItem('abcDraft')),
  };
};
